<template>
  <div id="app">
    <Head/>
    <router-view/>
    <Foot/>
  </div>
</template>

<script>
import Head from '@/components/Head';
import Foot from '@/components/Foot'
export default {
  name: 'app',
  components: {
    Head,
    Foot
  },
  data() {
    return {

    }
  }
}
</script>

<style>
</style>
